import { generateJsxKey } from '@utils/ast';
import { SliderComponent } from './_slider.js';
import { jsx } from 'react/jsx-runtime';

const printSliderComponent = (node, context) => {
  return /*#__PURE__*/jsx(SliderComponent, {
    ...node
  }, generateJsxKey(context));
};
const sliderComponentJsxPrinters = {
  "slider-component": printSliderComponent
};

export { printSliderComponent, sliderComponentJsxPrinters };
//# sourceMappingURL=printer.to-jsx.js.map
